


























import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { CART_API_ADDITIONAL } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { IMeta } from '~/assets/interfaces/meta'
import ComponentProductAdditionalWrapper from '~/components/products/product-additional-wrapper.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentOrderCart from '~/components/order/cart.vue'
import ComponentMobileOrderCart from '~/components/mobile/order/m-cart.vue'

const pageStore = namespace('page')
const cartStore = namespace('cart')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentOrderCart,
    ComponentMobileOrderCart,
    ComponentProductAdditionalWrapper,
  },
})
export default class pageCartIndex extends Vue {
  private async asyncData({ $axios }: { $axios: NuxtAppOptions }) {
    const response = await $axios.$get(CART_API_ADDITIONAL)

    return response
  }

  @cartStore.Action('getItems') private cartGetItems!: () => Promise<void>

  private isCanBuyOneClick = false
  private products: number[] = []

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
    }
  }

  private styleSpacer!: IStyle

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  private meta: IMeta | null = null
  private async created() {
    await this.cartGetItems()
    await this.setMeta({
      h1: 'Корзина',
      title: 'Корзина',
    })
  }
}
